/**
 * String enum representing programming languages supported by Papyros
 */
export var ProgrammingLanguage;
(function (ProgrammingLanguage) {
    ProgrammingLanguage["Python"] = "Python";
    ProgrammingLanguage["JavaScript"] = "JavaScript";
})(ProgrammingLanguage || (ProgrammingLanguage = {}));
//# sourceMappingURL=ProgrammingLanguage.js.map